import { VApplication } from "../../../application";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_PRESENTATION_LIST, GET_COSTUMETYPES } from "../graphql";
import { LoggerModule } from "@vlinder-web/logger-module-react";

const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class PresentationListService {
  public async getPresentationListProps(args: any) {
    try {
      const graphqlModule = getGraphQLModule();
      const client = graphqlModule.getClient("graphql-gateway");
      const filter_apply: any = {};

      const presentationRes = await client.query({
        query: GET_PRESENTATION_LIST,
        variables: {
          options: {
            limit: 100,
            skip: 0,
            sort: { order: "asc", field: "name" },
          },
          filter: {},
        },
        fetchPolicy: "network-only",
      });

      const presentationPayload = presentationRes?.data?.getPresentations;
      const presentations = Array.isArray(presentationPayload?.content)
        ? presentationPayload.content
        : [];

      const activePresentation =
        presentations.find(
          (item: any) => String(item?.status).toLowerCase() === "active",
        ) ??
        presentations?.[0] ??
        null;

      const activePresentationId = activePresentation?.id ?? null;

      const presentationOptions = presentations.map((item: any) => ({
        label: item?.name ?? "-",
        value: item?.id,
        status: item?.status,
        year: item?.year,
        country: item?.country,
        type: item?.type,
      }));

      const selectedPresentationId =
        args?.presentationId ||
        args?.filter?.presentation ||
        args?.filter?.presentationId ||
        activePresentationId;

      if (selectedPresentationId) {
        filter_apply.presentation = {
          eq: selectedPresentationId,
        };
      }

      if (args?.filter?.commonSearch) {
        filter_apply.commonSearch = args.filter.commonSearch;
      }

      const costumeTypeRes = await client.query({
        query: GET_COSTUMETYPES,
        variables: {
          options: {
            limit: args?.size ?? 10,
            skip: args?.offset ?? 0,
            sort: { order: "asc", field: "status" },
          },
          filters: filter_apply,
        },
        fetchPolicy: "network-only",
      });

      const costumeTypePayload =
        costumeTypeRes?.data?.getFullCostumeFeatureInventories;
      const totalCount = costumeTypePayload?.count ?? 0;
      const limit = costumeTypePayload?.limit ?? args?.size ?? 10;
      const skip = costumeTypePayload?.skip ?? args?.offset ?? 0;

      const totalPages = totalCount ? Math.ceil(totalCount / limit) : 1;
      const currentPage = limit ? skip / limit + 1 : 1;

      const rowData = this.formatNotesTable(costumeTypePayload?.content ?? []);

      return {
        ultUsers: rowData,
        isEmpty: totalCount <= 0,
        presentations,
        presentationOptions,
        activePresentation,
        activePresentationId,
        selectedPresentationId,
        currentPage,
        activePage: currentPage,
        pageSize: limit,
        totalCount,
        totalPages,
      };
    } catch (err: any) {
      console.error("Error in getPresentationListProps:", err);
      const displayError =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);

      if (displayError?.extensions?.display_message) {
        throw Error(displayError.extensions.display_message);
      }
      throw err;
    }
  }

  private formatNotesTable(costumeTypes: any[]) {
    if (!Array.isArray(costumeTypes)) return [];

    const notesRows: any[] = [];

    costumeTypes.forEach((item: any) => {
      const sectionName = item?.name?.split("-")?.[0]?.trim() ?? "-";
      const noteText = item?.note ?? "";

      notesRows.push({
        id: item?.id,
        costumeTypeId: item?.id,
        sectionOptionType: "-",
        section: sectionName,
        generic: item?.isCommon === true ? "Global" : "Section Specific",
        feature: item?.name ?? "-",
        attribute: "-",
        value: "-",
        note: noteText,
        noteStatus: noteText.trim().length > 0 ? "Added" : "Pending",
        lastUpdated: item?.updatedAt || null,
      });
    });

    return notesRows;
  }
}
